const GENDER = [
    {
        value: 1,
        text: "Male"
    },
    {
        value: 2,
        text: "Female"
    }
];

const CIVIL_STATUS = [
    {
        value: 1,
        text: "Single"
    },
    {
        value: 2,
        text: "Married"
    },
    {
        value: 3,
        text: "Divorced"
    },
    {
        value: 4,
        text: "Widowed"
    }
];

export function getGender(value) {
    return GENDER.find(item => item.value == value) || null;
}

export function getCivilStatus(value) {
    return CIVIL_STATUS.find(item => item.value == value) || null;
}

export default {
    getCivilStatus,
    getGender
}